/*
  2022-02-03
*/

import { number, string } from 'prop-types'

export const ReviewsSummary_v1 = {
  language: string,
  averageRating: number,
  ratingCount: number,
  starsOne: number,
  starsTwo: number,
  starsThree: number,
  starsFour: number,
  starsFive: number,
  variant_code: string,
}
